<div *ngIf="isDevelopment" class="theme-switcher-container"
     (dragover)="onDragOver($event)"
     (drop)="onDrop($event)">

  <button class="theme-switcher-toggle"
          (click)="toggleSwitcher()"
          [class.active]="isOpen"
          draggable="true"
          (dragstart)="onDragStart($event)"
          title="Theme Switcher (Dev Only)">
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M12 18.5C15.5899 18.5 18.5 15.5899 18.5 12C18.5 8.41015 15.5899 5.5 12 5.5C8.41015 5.5 5.5 8.41015 5.5 12C5.5 15.5899 8.41015 18.5 12 18.5Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 1.5V3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M12 20.5V22.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.22 4.22L5.64 5.64" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.36 18.36L19.78 19.78" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M1.5 12H3.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M20.5 12H22.5" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M4.22 19.78L5.64 18.36" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path d="M18.36 5.64L19.78 4.22" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  </button>

  <div class="theme-switcher-panel" [class.open]="isOpen">
    <div class="panel-header">
      <h3>🎨 Theme Switcher</h3>
      <button class="close-btn" (click)="toggleSwitcher()" title="Close">×</button>
    </div>

    <div class="panel-content">
      <div class="current-theme-info">
        <p class="info-label">Current Theme:</p>
        <p class="info-value">{{ currentTheme?.clientName || 'Loading...' }}</p>
        <p class="info-label">Tenant ID:</p>
        <p class="info-value">{{ currentTenant }}</p>
      </div>

      <div class="theme-list">
        <p class="section-label">Quick Switch:</p>
        <button *ngFor="let theme of availableThemes"
                class="theme-btn"
                [class.active]="currentTenant === theme"
                [disabled]="isLoading"
                (click)="switchTheme(theme)">
          {{ theme | titlecase }}
        </button>
      </div>

      <div class="custom-theme">
        <p class="section-label">Custom Tenant:</p>
        <div class="input-group">
          <input type="text"
                 [(ngModel)]="customTenant"
                 placeholder="Enter tenant ID"
                 (keyup.enter)="loadCustomTheme()"
                 [disabled]="isLoading">
          <button (click)="loadCustomTheme()"
                  [disabled]="isLoading || !customTenant.trim()">
            Load
          </button>
        </div>
      </div>

      <div class="actions">
        <button class="action-btn reload"
                (click)="reloadTheme()"
                [disabled]="isLoading">
          <span>↻</span> Reload Current
        </button>
      </div>

      <div *ngIf="isLoading" class="loading-indicator">
        <div class="spinner"></div>
        <span>Loading theme...</span>
      </div>

      <div class="dev-note">
        <small>💡 This panel is only visible in development mode</small>
      </div>
    </div>
  </div>
</div>